import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { alertActions } from '_actions';
import ReactDatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { getDateMDYYYY } from '_helpers';
import styles from './DateField.module.css'

class DateField extends React.Component {

    handleValueChange(date) {
        let minDate = this.props.minDate ? new Date(this.props.minDate) : new Date('1900/01/01');
        let maxDate = this.props.maxDate ? new Date(this.props.maxDate) : new Date('2100/01/01');
        if (date instanceof Date === false) {
            this.props.alertWarning('The date value was invalid.');
            date = null;
        }
        else if (date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime()) {
            let customMsg = this.props.customMsg ? this.props.customMsg : undefined;
            if (!customMsg) {
                if (minDate.getTime() === new Date('1900/01/01').getTime() && maxDate.getTime() !== new Date('2100/01/01').getTime()) {
                    customMsg = '  The date must be ' + getDateMDYYYY(maxDate) + ' or earlier.';
                }
                else if (minDate.getTime() !== new Date('1900/01/01').getTime() && maxDate.getTime() === new Date('2100/01/01').getTime()) {
                    customMsg = '  The date must be ' + getDateMDYYYY(minDate) + ' or after.';
                }
                else {
                    customMsg = '  The date must be in the range of 1/1/1900 to 1/1/2100.';
                }
                customMsg = 'The date was not in the valid range.' + customMsg;
            }

            this.props.alertWarning(customMsg);
            date = null;
        }
        if (!this.props.disabled && this.props.handleValueChange) {
            this.props.handleValueChange(date);
        }

    }

    render() {
        return (
            <div className={styles.wrapper}>
                <span className={styles.icon}>
                    <FontAwesomeIcon icon={faCalendarAlt} style={{ zIndex: -999 }} />
                </span>
                <ReactDatePicker
                    className={this.props.disabled ? styles.picker_disabled : this.props.required ? styles.picker_required : styles.picker}
                    selected={this.props.date}
                    onChange={(date) => this.handleValueChange(date)}
                    placeholderText='m/d/yyyy'
                    dateFormat='M/d/yyyy'
                    todayButton='Today'
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    return {};
}

const connectedDateField = connect(mapStateToProps, mapDispatchToProps)(DateField);
export { connectedDateField as DateField };